module.exports = __webpack_public_path__ + "media/images/lb/218-7b7c62f510bc68fd104378015cfcb9fe.svg";